import { get_tencrypt_key } from './tencrypt.util';


const hexToArrayBuffer = (hex) => {
  const bytes = new Uint8Array(hex.match(/.{1,2}/g).map(byte => Number.parseInt(byte, 16)));
  return bytes.buffer;
};


const stringToArrayBuffer = (str) => {
  return new TextEncoder().encode(str);
};


const arrayBufferToString = (buffer) => {
  return new TextDecoder().decode(buffer);
};


const decryptWithWebCrypto = async (encryptedValue, algorithm, key, iv) => {
  try {
    const encryptedBuffer = hexToArrayBuffer(encryptedValue);
    
    const keyBuffer = stringToArrayBuffer(key);
    const ivBuffer = stringToArrayBuffer(iv);

    const cryptoKey = await window.crypto.subtle.importKey(
      'raw',
      keyBuffer,
      { name: 'AES-CBC' },
      false,
      ['decrypt']
    );

    const decryptedBuffer = await window.crypto.subtle.decrypt(
      { name: 'AES-CBC', iv: ivBuffer },
      cryptoKey,
      encryptedBuffer
    );
    
    const result = arrayBufferToString(decryptedBuffer);
    return result;
  } catch (error) {
    console.error('❌ Error en Web Crypto API:', error);
    throw error;
  }
};

export const decrypt_value = async (encryptedValue, tencryptConfig = null) => {
  const config = tencryptConfig || get_tencrypt_key();
    
  if (!config) {
    throw new Error('TENCRYPT_KEY no encontrada');
  }

  const [algorithm, key, sign] = config.split('|');
    
  if (!algorithm || !key || !sign) {
    throw new Error('Configuración TENCRYPT inválida');
  }

  const result = await decryptWithWebCrypto(encryptedValue, algorithm, key, sign);
  return result;
};

export const decrypt_and_parse_json = async (encryptedValue) => {
  try {
    const decryptedString = await decrypt_value(encryptedValue);
    
    if (typeof decryptedString === 'string') {
      const parsed = JSON.parse(decryptedString);
      return parsed;
    } else {
      return decryptedString;
    }
  } catch (error) {
    throw new Error(`Error al desencriptar: ${error.message}`);
  }
};

export default { decrypt_value, decrypt_and_parse_json };
